import React from "react";
import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/dracula";
import PythonSVG from "../../../../../assets/images/code-python.svg";
import JavascriptSVG from "../../../../../assets/images/code-jss.svg";
import CsharpSVG from "../../../../../assets/images/code-csharp.svg";
import JsonSVG from "../../../../../assets/images/code-json.svg";

// Python Sample Code
const python = `
import requests

url = "{BaseURI}/api/connect/token"

payload={}
headers = {
  'Authorization': 'Basic Og=='
}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)

`;

// JS Sample Code
const javascript = `
var myHeaders = new Headers();
myHeaders.append("Authorization", "Basic Og==");

var requestOptions = {
  method: 'POST',
  headers: myHeaders,
  redirect: 'follow'
};

fetch(BaseURI+"/api/connect/token", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.log('error', error));

`;

// C# Sample Code
const csharp = `
var client = new RestClient(BaseURI+“/api/connect/token");
var request = new RestRequest(Method.POST);

request.AddHeader("Authorization", "Basic Og==");
IRestResponse response = client.Execute(request);

Console.WriteLine(response.Content);
`;

function CodeTabs() {
  return (
    <>
      <ul className="nav nav-tabs" id="myTab" role="tablist">
        <li className="nav-item">
          <button
            className="nav-link active"
            id="python-tab"
            data-bs-toggle="tab"
            data-bs-target="#python-tab-pane"
            type="button"
            role="tab"
            aria-controls="python-tab-pane"
            aria-selected="true"
          >
            <img src={PythonSVG} alt="Python" />
            Python
          </button>
        </li>
        <li className="nav-item">
          <button
            className="nav-link"
            id="Javascript-tab"
            data-bs-toggle="tab"
            data-bs-target="#Javascript-tab-pane"
            type="button"
            role="tab"
            aria-controls="Javascript-tab-pane"
            aria-selected="false"
          >
            <img src={JavascriptSVG} alt="JavaScript" />
            Javascript
          </button>
        </li>
        <li className="nav-item">
          <button
            className="nav-link"
            id="csharp-tab"
            data-bs-toggle="tab"
            data-bs-target="#csharp-tab-pane"
            type="button"
            role="tab"
            aria-controls="csharp-tab-pane"
            aria-selected="false"
          >
            <img src={CsharpSVG} alt="C#" />
            C#
          </button>
        </li>
        <li className="nav-item">
          <button
            className="nav-link"
            id="json-tab"
            data-bs-toggle="tab"
            data-bs-target="#json-tab-pane"
            type="button"
            role="tab"
            aria-controls="json-tab-pane"
            aria-selected="false"
          >
            <img src={JsonSVG} alt="JSON" />
            JSON
          </button>
        </li>
      </ul>
      <div className="tab-content" id="myTabContent">
        <div
          className="tab-pane fade show active"
          id="python-tab-pane"
          role="tabpanel"
          aria-labelledby="python-tab"
          tabIndex="0"
        >
          <Highlight
            {...defaultProps}
            code={python}
            theme={theme}
            language="python"
            data-copy="copy"
          >
            {({ className, style, tokens, getLineProps, getTokenProps }) => (
              <pre className={className} style={style}>
                {tokens.map((line, i) => (
                  <div {...getLineProps({ line, key: i })}>
                    {line.map((token, key) => (
                      <span {...getTokenProps({ token, key })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </div>
        <div
          className="tab-pane fade"
          id="Javascript-tab-pane"
          role="tabpanel"
          aria-labelledby="Javascript-tab"
          tabIndex="0"
        >
          <Highlight
            {...defaultProps}
            code={javascript}
            theme={theme}
            language="jsx"
          >
            {({ className, style, tokens, getLineProps, getTokenProps }) => (
              <pre className={className} style={style}>
                {tokens.map((line, i) => (
                  <div {...getLineProps({ line, key: i })}>
                    {line.map((token, key) => (
                      <span {...getTokenProps({ token, key })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </div>
        <div
          className="tab-pane fade"
          id="csharp-tab-pane"
          role="tabpanel"
          aria-labelledby="csharp-tab"
          tabIndex="0"
        >
          <Highlight
            {...defaultProps}
            code={csharp}
            theme={theme}
            language="js"
          >
            {({ className, style, tokens, getLineProps, getTokenProps }) => (
              <pre className={className} style={style}>
                {tokens.map((line, i) => (
                  <div {...getLineProps({ line, key: i })}>
                    {line.map((token, key) => (
                      <span {...getTokenProps({ token, key })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </div>
        <div
          className="tab-pane fade"
          id="json-tab-pane"
          role="tabpanel"
          aria-labelledby="json-tab"
          tabIndex="0"
        >
          <Highlight
            {...defaultProps}
            code={javascript}
            theme={theme}
            language="jsx"
          >
            {({ className, style, tokens, getLineProps, getTokenProps }) => (
              <pre className={className} style={style}>
                {tokens.map((line, i) => (
                  <div {...getLineProps({ line, key: i })}>
                    {line.map((token, key) => (
                      <span {...getTokenProps({ token, key })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </div>
      </div>
    </>
  );
}
export default CodeTabs;
